import React from 'react';
import { LegalLayout } from './LegalLayout';
import { company } from '../data/content';

export default function Datenschutz() {
  return (
    <LegalLayout title="Datenschutzerklärung" subtitle="Informationen zur Verarbeitung Ihrer personenbezogenen Daten gemäß Art. 13 DSGVO" testId="datenschutz-page">
      <h2>1. Verantwortlicher</h2>
      <p>
        Verantwortlich für die Datenverarbeitung auf dieser Website ist:<br />
        <strong>{company.name}</strong>, Inhaber {company.owner}<br />
        {company.address.street}, {company.address.zip} {company.address.city}<br />
        Telefon: <a href={`tel:${company.phoneRaw}`}>{company.phone}</a> · E-Mail: <a href={`mailto:${company.email}`}>{company.email}</a>
      </p>

      <h2>2. Allgemeine Hinweise</h2>
      <p>
        Wir nehmen den Schutz Ihrer persönlichen Daten sehr ernst und behandeln Ihre personenbezogenen Daten vertraulich sowie entsprechend der
        gesetzlichen Datenschutzvorschriften (DSGVO, BDSG, TDDDG) und dieser Datenschutzerklärung. Personenbezogene Daten sind alle Daten, mit denen Sie
        persönlich identifiziert werden können.
      </p>

      <h2>3. Hosting und Server-Logfiles</h2>
      <p>
        Diese Website wird bei {company.hosting} gehostet. Beim Aufruf dieser Website werden durch den Hosting-Anbieter automatisch Informationen in sogenannten Server-Logfiles erfasst, die Ihr Browser
        übermittelt: IP-Adresse, Datum und Uhrzeit der Anfrage, aufgerufene Seite, Browsertyp und -version, verwendetes Betriebssystem sowie Referrer-URL.
        Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO aus unserem berechtigten Interesse an einer sicheren, stabilen und
        fehlerfreien Bereitstellung der Website. Die Daten werden nicht mit anderen Datenquellen zusammengeführt.
      </p>

      <h2>4. Kontaktformular</h2>
      <p>
        Wenn Sie uns über das Kontaktformular eine Anfrage senden, werden Ihre Angaben aus dem Formular (Name, E-Mail-Adresse, optional Telefonnummer,
        Firma, Ort/Objektadresse, gewünschte Leistung und Nachricht) zur Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert.
        Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO (Vertragsanbahnung) sowie Art. 6 Abs. 1 lit. a DSGVO (Ihre Einwilligung).
        Sie können Ihre Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen.
      </p>
      <p>
        Die eingegebenen Daten verbleiben bei uns, bis Sie uns zur Löschung auffordern, Ihre Einwilligung widerrufen oder der Zweck der Speicherung
        entfällt (z.&nbsp;B. nach abgeschlossener Bearbeitung Ihrer Anfrage). Zwingende gesetzliche Aufbewahrungsfristen bleiben unberührt.
      </p>

      <h2>5. Foto-Upload im Kontaktformular</h2>
      <p>
        Sie haben die Möglichkeit, Ihrer Anfrage Fotos der zu bearbeitenden Fläche beizufügen. Die hochgeladenen Bilder werden ausschließlich zur
        Einschätzung Ihres Anliegens und zur Angebotserstellung verwendet und in einem gesicherten Objektspeicher abgelegt, der nur über unser System
        zugänglich ist. Bitte laden Sie keine Bilder hoch, auf denen andere Personen erkennbar sind. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO.
        Die Bilder werden gelöscht, sobald sie für die Bearbeitung nicht mehr erforderlich sind, spätestens jedoch auf Ihre Aufforderung.
      </p>

      <h2>6. Kontaktaufnahme per Telefon, E-Mail oder WhatsApp</h2>
      <p>
        Kontaktieren Sie uns per Telefon oder E-Mail, werden die übermittelten Daten zur Bearbeitung Ihres Anliegens verarbeitet (Art. 6 Abs. 1 lit. b DSGVO).
        Über den WhatsApp-Button können Sie uns über den Dienst WhatsApp der WhatsApp Ireland Limited, 4 Grand Canal Square, Dublin 2, Irland kontaktieren.
        Dabei gelten die Datenschutzbestimmungen von WhatsApp. Die Nutzung ist freiwillig; alternativ stehen Ihnen Telefon, E-Mail und Kontaktformular zur Verfügung.
      </p>

      <h2>7. Cookies und Tracking</h2>
      <p>
        Diese Website verwendet keine Tracking-Cookies, keine Analyse-Tools und keine Werbenetzwerke. Es werden ausschließlich technisch notwendige
        Funktionen genutzt, für die keine Einwilligung erforderlich ist.
      </p>

      <h2>8. Externe Inhalte und Links</h2>
      <p>
        Beim Klick auf externe Links (z.&nbsp;B. Google Maps zur Anfahrt) verlassen Sie unsere Website. Für die Datenverarbeitung auf den Zielseiten ist der
        jeweilige Anbieter verantwortlich.
      </p>

      <h2>9. Ihre Rechte</h2>
      <p>Sie haben gegenüber uns folgende Rechte hinsichtlich der Sie betreffenden personenbezogenen Daten:</p>
      <ul>
        <li>Recht auf Auskunft (Art. 15 DSGVO)</li>
        <li>Recht auf Berichtigung (Art. 16 DSGVO)</li>
        <li>Recht auf Löschung (Art. 17 DSGVO)</li>
        <li>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
        <li>Recht auf Datenübertragbarkeit (Art. 20 DSGVO)</li>
        <li>Recht auf Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)</li>
        <li>Recht auf Widerruf einer erteilten Einwilligung (Art. 7 Abs. 3 DSGVO)</li>
      </ul>
      <p>
        Zur Ausübung Ihrer Rechte genügt eine formlose Mitteilung an <a href={`mailto:${company.email}`}>{company.email}</a>. Sie haben zudem das Recht,
        sich bei einer Datenschutz-Aufsichtsbehörde zu beschweren. Zuständig ist das Unabhängige Landeszentrum für Datenschutz Schleswig-Holstein (ULD),
        Holstenstraße 98, 24103 Kiel.
      </p>

      <h2>10. Datensicherheit</h2>
      <p>
        Diese Website nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte eine SSL-/TLS-Verschlüsselung. Eine verschlüsselte
        Verbindung erkennen Sie am Schloss-Symbol in Ihrer Browserzeile.
      </p>

      <h2>11. Aktualität dieser Datenschutzerklärung</h2>
      <p>Diese Datenschutzerklärung ist aktuell gültig und hat den Stand Juni 2026. Wir behalten uns vor, sie bei Änderungen der Rechtslage oder unseres Angebots anzupassen.</p>
    </LegalLayout>
  );
}
